export default "__VITE_ASSET__A0J2VGRT__"